import { render, staticRenderFns } from "./Project4Zh.vue?vue&type=template&id=5006a11b&scoped=true&"
import script from "./Project4Zh.vue?vue&type=script&lang=js&"
export * from "./Project4Zh.vue?vue&type=script&lang=js&"
import style0 from "./Project4Zh.vue?vue&type=style&index=0&id=5006a11b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5006a11b",
  null
  
)

export default component.exports